<template>
  <div>
    <div class="wrapper position-relative mb-4">
      <div class="placeholder timeline" />
    </div>

    <div class="wrapper position-relative mb-4">
      <div class="placeholder breakdown" />
    </div>

    <div class="wrapper position-relative mb-4">
      <div class="placeholder table" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyPlaceholder'
}
</script>

<style scoped lang="scss">
.wrapper {
  border: 2px solid #ececef;
  border-radius: 8px;
  padding: 10px 20px 0;
  background: $color-white;
}

.placeholder {
  border-radius: 0 8px 8px 8px;
  width: 100%;
  height: auto;
  min-height: 320px;
  margin: 20px 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &.breakdown {
    background-image: asset("img/placeholders/graph-dummy-sm.svg");
  }

  &.timeline {
    background-image: asset("img/placeholders/timeline-graph-sm.svg");
  }

  &.table {
    background-image: asset("img/placeholders/table-graph-sm.svg");
  }

  @include media-breakpoint-up($sm) {
    background-size: contain;

    &.breakdown {
      background-image: asset("img/placeholders/graph-dummy-md.svg");
    }

    &.timeline {
      background-image: asset("img/placeholders/timeline-graph-md.svg");
    }

    &.table {
      background-image: asset("img/placeholders/table-graph-md.svg");
    }
  }

  @include media-breakpoint-up($lg) {
    &.breakdown {
      background-image: asset("img/placeholders/graph-dummy.svg");
    }

    &.timeline {
      background-image: asset("img/placeholders/timeline-graph.svg");
    }

    &.table {
      background-image: asset("img/placeholders/table-graph.svg");
    }
  }
}

.placeholder-img {
  left: 0;
  right: 0;
  top: 20px;
}
</style>
